module.exports = __webpack_public_path__ + "static/media/py.d83a7fa8.hdr";